//dependencies
import dropdown from "angular-ui-bootstrap/src/dropdown";
import collapse from "angular-ui-bootstrap/src/collapse";
import tabs from "angular-ui-bootstrap/src/tabs";
import ngSanitize from "angular-sanitize";

//services

//components
import customerMerge from "emun.customer/merge/customer-merge";

export const dependencies = [dropdown, collapse, tabs, ngSanitize];

export const modules = {
  // modals,
};
//states
import states from "emun.customer/merge/customer-merge.states";

export const services = {};

export const components = {
  customerMerge,
};

export const directives = {};

export default {
  modules,
  services,
  dependencies,
  components,
  directives,
  states
};
